const AuthLayout = () => import(/* webpackChunkName: "auth" */ './components/Layout');
const Login = () => import(/* webpackChunkName: "auth" */ './components/Login');
const GuestApplication = () => import(/* webpackChunkName: "auth" */ './components/GuestApplication');
const GuestUploads = () => import(/* webpackChunkName: "auth" */ './components/GuestUploads');
const StyleSheet = () => import(/* webpackChunkName: "auth" */ './components/StyleSheet');
const Logout = () => import(/* webpackChunkName: "auth" */ './components/Logout');
const ChangePassword = () => import(/* webpackChunkName: "auth" */ './components/ChangePassword');
const AccessibilityPolicy = () => import(/* webpackChunkName: "auth" */ './components/AccessibilityPolicy');

const SigningCompletePage = () => import( '../pages/signingPage/index.vue');

export default [
	{
		path: '/auth',
		component: AuthLayout,
		redirect: '/login',
		children: [

			{
				name: 'Login',
				path: 'login',
				component: Login
			},

			{
				name: 'Logout',
				path: 'logout',
				component: Logout,
				meta: {requiresAuth: true}
			}

		]
	},

	{
		name: 'GuestApplication',
		path: '/guest-application/:applicationId?',
		component: GuestApplication,
		meta: {requiresAuth: false}
	},

	{
		name: 'GuestUploads',
		path: '/guest-uploads/:applicationId?',
		component: GuestUploads,
		meta: {requiresAuth: false}
	},

	{
		name: 'StyleSheet',
		path: '/style-sheet',
		component: StyleSheet,
		meta: {requiresAuth: false}
	},

	{
		name: 'SigningComplete',
		path: '/finished',
		component: SigningCompletePage,
		meta: {requiresAuth: false}
	}

];

export const AfterAuthRoutes = [

	{
		name: 'ChangePassword',
		path: 'change-password',
		component: ChangePassword,
		meta: {requiresAuth: false}
	},

	{
		name: 'AccessibilityPolicy',
		path: 'accessibility-policy',
		component: AccessibilityPolicy,
		meta: {requiresAuth: false}
	}

];
